import styled from 'styled-components';

export const WrapperCookies = styled.div`
  background: #2253f5;
  color: #ffffff;

  font-family: 'Montserrat', sans-serif;
  h1,
  h2,
  h3,
  p,
  a {
    margin: 0;
  }

  a {
    text-decoration: none;
    color: #64728c;
  }

  div.cookies-1 {
    max-width: 750px;
    text-align: center;
    margin: 0 auto;
    padding-top: 125px;

    h1 {
      font-size: 48px;
      line-height: 56px;
    }

    p {
      max-width: 620px;
      margin: 30px auto;

      font-family: Source Sans Pro;
      font-weight: 300;
      font-size: 24px;
      line-height: 32px;

      color: #ffffff;
    }

    @media (max-width: 768px) {
      max-width: 340px;
      padding-top: 40px;

      h1 {
        font-size: 30px;
        line-height: 32px;
      }

      p {
        max-width: 400px;
        margin: 20px auto;

        font-size: 24px;
        line-height: 24px;
      }
    }
  }

  div.apps {
    width: 100%;
    height: 200px;
    background: url('/iconeshome.png') center repeat-x;

    @media (max-width: 768px) {
      height: 65px;
      background: url('/iconeshome.png') top repeat-x;
    }
  }

  section.partnership2 {
    padding: 100px 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    h2 {
      margin-bottom: 20px;
      font-family: Montserrat;
      font-size: 32px;
      text-align: center;

      color: #2253f5;
    }

    div {
      width: 55%;
      display: flex;
      flex-direction: column;
      align-items: right;

      h1 {
        margin-bottom: 20px;
        font-family: Montserrat;
        font-size: 27.5831px;
        text-align: left;

        color: #333333;
      }

      p {
        font-family: Source Sans Pro;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 32px;
        max-width: 842px;

        color: #64728c;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 100px 60px;

      div {
        width: 100%;
        margin: 0 !important;
        flex-wrap: wrap;

        h1 {
          font-size: 16px;
          text-align: left;
          line-height: 140.62%;
          margin-top: -30px;
        }

        h2 {
          font-size: 17px;
          text-align: center;
        }

        p {
          text-align: left;
          width: 100% !important;
          font-size: 14px;
          line-height: 18px;
        }
      }
    }
  }
`;
